import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { getAllRegionListFailure, getAllRegionListSuccess } from '../../actions/publicActions/getAllRegionsActions';
import store from '../../configStore';

function* getAllRegionList({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllRegion,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_ALL_REGIONS_SUCCESS status :", response.data.status);
        console.log("GET_ALL_REGIONS_SUCCESS data :", response.data.response);
        console.log("GET_ALL_REGIONS_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getAllRegionListSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_ALL_REGIONS_FAILURE status :", error?.response?.status);
        console.log("GET_ALL_REGIONS_FAILURE data:", error?.response?.data);
        console.log("GET_ALL_REGIONS_FAILURE error :", error);
        console.log('====================================');
        yield put(getAllRegionListFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getAllRegionListSaga() {
    yield takeLatest(actionTypes.GET_ALL_REGIONS_REQUEST, getAllRegionList);
}

export default getAllRegionListSaga;
